import type { AuditAction, AuditLog } from '@/domain';
import { mockStore } from '@/lib/mock-store';
import { getSupabase, isMockBackend } from '@/lib/supabase';

interface LogInput {
  actor: string;
  action: AuditAction;
  entity_type: string;
  entity_id?: string | null;
  summary: string;
  payload?: Record<string, unknown>;
}

function randomId(): string {
  return `audit_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export const auditService = {
  async log(input: LogInput): Promise<void> {
    const entry: AuditLog = {
      id: randomId(),
      actor: input.actor,
      action: input.action,
      entity_type: input.entity_type,
      entity_id: input.entity_id ?? null,
      summary: input.summary,
      payload: input.payload ?? {},
      created_at: new Date().toISOString(),
    };

    if (isMockBackend) {
      mockStore.append('audit_log', entry);
      return;
    }
    const supabase = getSupabase()!;
    const { error } = await supabase.from('audit_log').insert(entry);
    if (error) throw error;
  },

  async list(limit = 50): Promise<AuditLog[]> {
    if (isMockBackend) {
      return mockStore
        .getAll('audit_log')
        .sort((a, b) => b.created_at.localeCompare(a.created_at))
        .slice(0, limit);
    }
    const supabase = getSupabase()!;
    const { data, error } = await supabase
      .from('audit_log')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(limit);
    if (error) throw error;
    return (data ?? []) as AuditLog[];
  },
};
